import TimelineDot from '@material-ui/lab/TimelineDot';

export default TimelineDot;
